'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalInputCaption_web = require('../../internal/InternalTextInput/InternalInputCaption/InternalInputCaption.web.cjs');
require('@emotion/react');
require('react');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../../../../../../_virtual/index.cjs');
var useInputFocus = require('../../../utils/hooks/useInputFocus.cjs');
var TextArea_web_styles = require('./TextArea.web.styles.cjs');

/**
 * TextArea component is a multi-line plain-text input
 *
 * {@link https://aviary.fullscript.io/latest/components/text-area/web-OHS52nUx | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/TextArea/TextArea.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const TextArea = ({ id, disabled, readOnly, onChange, noResize = false, inputCaption, customWrapperStyles, customInputStyles, ...rest })=>{
    const { isKeyboardFocused, handleFocus, handleBlur, textAreaInputRef } = useInputFocus.useInputFocus();
    const containerStyles = [
        TextArea_web_styles.containerStyles.base,
        disabled && TextArea_web_styles.containerStyles.disabled,
        readOnly && TextArea_web_styles.containerStyles.readOnly,
        customWrapperStyles
    ];
    const inputStyles = [
        [
            TextArea_web_styles.textArea,
            noResize && TextArea_web_styles.noResize
        ],
        customInputStyles
    ];
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: containerStyles,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: isKeyboardFocused && TextArea_web_styles.keyboardFocusRing,
                children: /*#__PURE__*/ jsxRuntime.jsx("textarea", {
                    id: id,
                    ref: textAreaInputRef,
                    disabled: disabled,
                    css: inputStyles,
                    onChange: onChange,
                    onBlur: handleBlur,
                    onFocus: handleFocus,
                    readOnly: readOnly,
                    "data-testid": "aviary-text-area",
                    ...rest
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx(InternalInputCaption_web.InternalInputCaption, {
                id: id,
                inputCaption: inputCaption
            })
        ]
    });
};

exports.TextArea = TextArea;
//# sourceMappingURL=TextArea.web.cjs.map
